import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import AuthLayout from "../layout/AuthLayout";
import * as Containers from "../containers";
import PublicRoute from "../layout/PublicRoute";
import ProtectRoute from "../layout/ProtectRoute";

const Router = () => {
  return (
    <>
      <Routes>
        {/* DASHBOARD_ROUTES */}
        <Route element={<DashboardLayout />}>
          <Route
            path="/dashboard"
            element={
              <ProtectRoute>
                <Containers.Dashboard />
              </ProtectRoute>
            }
          />
          <Route
            path="/sr-technicions"
            element={
              <ProtectRoute>
                <Containers.SeniorTechNicions />
              </ProtectRoute>
            }
          />
          <Route
            path="/jr-technicions"
            element={
              <ProtectRoute>
                <Containers.JuniorTechnicions />
              </ProtectRoute>
            }
          />
          <Route
            path="/administrator"
            element={
              <ProtectRoute>
                <Containers.Administrator />
              </ProtectRoute>
            }
          />
        </Route>

        {/* AUTH_ROUTES */}
        <Route element={<AuthLayout />}>
          <Route
            path="/"
            element={
              <PublicRoute>
                <Containers.Login />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <Containers.ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/enter-otp"
            element={
              <PublicRoute>
                <Containers.EnterOtp />
              </PublicRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <Containers.ResetPassword />
              </PublicRoute>
            }
          />

          <Route path="*" element={<Containers.PageNotFound />} />
        </Route>
      </Routes>
    </>
  );
};

export default Router;
